import React from 'react';
import { useQuery } from 'react-query';
import Loading from '../Shared/Loading';
import UserRow from './UserRow';

const Users = () => {

    const { data: users, isLoading, refetch } = useQuery('users', () => fetch(`https://doctors-portal-1324.herokuapp.com/user`, {
        method: 'GET',
        headers: {
            'authorization': `Beater ${localStorage.getItem('accessToken')}`
        }
    }).then(res => res.json()));


    if (isLoading) {
        return <Loading />
    }

    return (
        <div>
            <h2 className="text-2xl font-bold mb-3">All Users {users.length} </h2>

            <div className="overflow-x-auto">
                <table className="table w-full text-center">
                    {/* <!-- head --> */}
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Date</th>
                            <th>Time</th>
                            <th>Treatment</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            users?.map((user, index) => <UserRow
                                key={user._id}
                                user={user}
                                refetch={refetch} />)
                        }



                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Users;